// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c4887ba3","879":"58a2c22a"}[chunkId] + ".chunk.js";
};